import { useMutation } from '@tanstack/react-query';
import type { IPatchCompanyRole } from 'api/resources/companyRole';
import { patchCompanyRole } from 'api/resources/companyRole';

export const usePatchCompanyRole = () =>
	useMutation((params: IPatchCompanyRole) => patchCompanyRole(params));
